// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BasePopUpLayer from "../../../../../engines/components/BasePopUpLayer";
import O1HD from "../../../../../engines/gameEngine";
import utilsModel from "../../../../../engines/libs/utilsModel";
import utilsView from "../../../../../engines/libs/utilsView";
import { FileKind } from "../../../../define/FileKind";

const {ccclass, property} = cc._decorator;

@ccclass
export default class SettleLawsuitSpecialSelect extends BasePopUpLayer {

	@property({ type: cc.Node, displayName:'' })
	sprBg: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	btnItem: cc.Node = null;

	@property(cc.Node)
	labelBtnItem: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	nodeList: cc.Node = null;

	@property({ type: cc.Label, displayName:'' })
	labelTitle: cc.Label = null;

   
	private spaceY = 0;
	private successIdx = -1;
    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {
		this.spaceY = this.sprBg.height - this.nodeList.height;
		this.initLayer();
    }

	initLayer() {
		let selectArr = this._carryData.selectArr;
		let selectSplits = utilsModel.splitLineFeed(selectArr);
		this.btnItem.active = false;

		let maxWidth = 0;
		let spaceX = this.btnItem.width - this.labelBtnItem.width;
		for (let i = 0; i < selectSplits.length; i++) {
			let o = selectSplits[i];
			let itemSplit = o.split(FileKind.ResParseType.SUB_ITEM);
			if (itemSplit[1]) {
				this.successIdx = i;
			}
			let btnItem = cc.instantiate(this.btnItem);
			let btnCom = btnItem.getComponent(cc.Button);
			btnCom.clickEvents[0].customEventData = '' + i;
			btnItem.active = true;
			this.nodeList.addChild(btnItem);

			let label = cc.find('Label', btnItem).getComponent(cc.Label);
			label.string = itemSplit[0];
			utilsView.refreshLabelUI(label);

			maxWidth = Math.max(maxWidth, spaceX + label.node.width);
		}

		this.nodeList.children.forEach((v)=> {
			v.width = maxWidth;
		});
		this.nodeList.getComponent(cc.Layout).updateLayout();

		this.sprBg.height = this.nodeList.height + this.spaceY;
	}

	onClickSelect(event: cc.Event.EventTouch, data) {
		O1HD.getManagers().soundMgr.playSound("anNiu").then();
		let idx = Number(data);
		this.destroyNode();
		this._carryData.parent.onClickSelectJudgment(
			this._carryData.idx
			, idx
			, this.successIdx == idx
		);
	}

	onClickClose() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.destroyNode();
    }

    // update (dt) {}
}
